@if (displayText() && displayIcon()) {
  <div
    test-id="refresh-job-data-on-refresh"
    class="tw:flex tw:items-center tw:py-2 tw:gap-1 tw:me-1 tw:cursor-pointer"
    [class.disabled]="isLoading()"
    (click)="onRefresh()">
    @if (isLoading()) {
      Refreshing ...
    } @else {
      <div class="tw:flex tw:items-center">
        <span class="tw:text-muted-color tw:me-2">
          Last updated at {{ lastUpdatedTime() | date: 'h:mm:ss a' }}
        </span>
        <i
          class="pi pi-sync"
          [pTooltip]="
            jobBoardPollingIntervalInSeconds()
              ? `Auto refresh is enabled for every ${jobBoardPollingIntervalInSeconds()} seconds`
              : 'Refresh Jobs'
          "
          tooltipPosition="left"
          aria-hidden="true"></i>
      </div>
    }
  </div>
} @else if (displayText()) {
  <div
    class="tw:flex tw:items-center tw:gap-1"
    [class.disabled]="isLoading()">
    @if (isLoading()) {
      Refreshing ...
    } @else {
      <span class="tw:text-muted-color">
        Last updated at {{ lastUpdatedTime() | date: 'h:mm:ss a' }}
      </span>
    }
  </div>
} @else if (displayIcon()) {
  <div
    test-id="refresh-job-data-on-refresh-2"
    class="tw:flex tw:cursor-pointer"
    [class.disabled]="isLoading()"
    (click)="onRefresh()">
    <i
      class="pi pi-sync"
      [class.pi-spin]="isLoading()"
      [pTooltip]="
        jobBoardPollingIntervalInSeconds()
          ? `Auto refresh is enabled for every ${jobBoardPollingIntervalInSeconds()} seconds`
          : 'Refresh Jobs'
      "
      tooltipPosition="left"
      aria-hidden="true"></i>
  </div>
}
